export { sdkMeta } from './meta';



// WEBPACK FOOTER //
// ../../../../src/metas/sdk/index.ts